<template>
  <div class="xxgn-wrap clearfix">
    <aside>
      <dl>
        <dt>核心功能</dt>
        <dd v-for="(menu, index) in menuList" :key="index">
          <span :class="{'cur':menu.id == menuId}" @click="selectMenu(menu.id)">{{menu.name}}</span>
          <ul v-show="menu.id == menuId">
            <li v-for="subMenu in menu.subMenuList" :key="subMenu.id" @click="selectSubMenuId(menu.id, subMenu.id)">{{subMenu.name}}</li>
          </ul>
        </dd>
      </dl>
    </aside>
    <div class="r-con">
      <article v-show="menuId == 1">
        <section v-show="subMenuId == 1">
          <h2>封板率</h2>
          <p>封板率：每日开盘前10分钟打板的个股往往是受到隔夜利好消息公告等刺激开盘就封板的个股，所以前10分钟封板率会很高，影响市场的判断。之后封板率的走向就真正了反映庄家操盘意向：封板率越低说明拉高出货意向越明显，封板率越高说明主力资金做多意向越强。</p>
          <img src="../../assets/images/product/113/img01.jpg" alt />
        </section>
        <section v-show="subMenuId == 2">
          <h2>大盘先锋</h2>
          <p>大盘先锋：大盘先锋是专门针对大盘指数设计的指标，基于大智慧ACE活跃资金估算数据，按每一笔主动性买卖单的成交额大小来监控上证、深证、中小板、创业板指数及板块指数主力资金的动向。指标线向上代表主动性主力资金净流入，向下代表主动性主力资金净流出。</p>
          <img src="../../assets/images/product/113/img02.jpg" alt />
        </section>
        <!-- <section v-show="subMenuId == 3">
          <h2>EDX 申赎动向</h2>
          <p>EDX 申赎动向：数据源自ETF申赎，对申赎数据进行量化分析，旨在揭示机构资金在一级市场的动向，进而研判二级市场总体走势。</p>
          <p>普通的资金流指标往往在大盘启动之后才会发出信号，而EDX指标的优势在于能提前抓住大盘指数的底部位置，洞察到反弹或拉升的初期阶段，从而避免了高位介入的风险，所以EDX是一个对二级市场趋势极具预判性而且风险较低的指标。</p>
          <img src="../../assets/images/product/113/img03.jpg" alt />
        </section> -->
      </article>
      <article v-show="menuId == 2">
        <section v-show="subMenuId == 1">
          <h2>昨日涨停分析</h2>
          <p>昨日涨停分析：领涨股、强势股、热点股、一目了然</p>
          <p>用法：从昨天强势股中筛选出热门，强者恒强</p>
          <img src="../../assets/images/product/113/img04.jpg" alt />
        </section>
        <section v-show="subMenuId == 2">
          <h2>ACE涨跌排序</h2>
          <p>ACE涨跌排序：潜力股、埋伏股、选金股看排序</p>
          <p>用法：1、根据增仓的数值大小来找出，当天资金介入，但没有明显涨幅的个股</p>
          <p>2、根据金额的多少来判断资金介入的深度和强度，筛选出有拉升预期的个股。</p>
          <img src="../../assets/images/product/113/img05.jpg" alt />
        </section>
        <section v-show="subMenuId == 3">
          <h2>主题投资</h2>
          <p>主题投资：网络市场热点，紧盯重大事件+潜在机会，监控主题异动</p>
          <p>用法：按照题材的涨幅和事件的重大程度来确定是否是当天热点，从热点中找到还未上涨的个股。</p>
          <img src="../../assets/images/product/113/img06.jpg" alt />
        </section>
        <section v-show="subMenuId == 4">
          <h2>股东深挖</h2>
          <p>股东深挖：挖掘低价埋伏股，洞悉主力建仓票</p>
          <p>用法：1、支持主力机构名称检索，直击重点股东走向，多维排序，无死角的有序查询，各类主力机构大资金一目了然，分类明确，精准定位各类主力动向。</p>
          <p>2、支持牛散查询，牛散持仓个股一键查询</p>
          <img src="../../assets/images/product/113/img07.jpg" alt />
        </section>
        <section v-show="subMenuId == 5">
          <h2>复盘神器</h2>
          <p>复盘神器：全面了解前天走势，复盘庄家操作手法</p>
          <p>每一次正确的选择和精准的判断，离不开长时间的积累和总结。盘中短短的4个小时，只能让投资者了解当天的行情涨跌情况，然而藏在背后的原因，庄家的操作心理，就需要投资者花更多的时间去挖掘。</p>
          <img src="../../assets/images/product/113/img08.jpg" alt />
        </section>
        <section v-show="subMenuId == 6">
          <h2>机构去哪</h2>
          <p>机构去哪：紧跟机构步伐，追踪热钱去向</p>
          <p>用法1、 每日第一时间推送机构调研记录，在时效性方面强于研究报告库</p>
          <p>2、 方便阅读机构去哪儿的具体报告</p>
          <p>3、 报告具有权威性。摘取自上市公司高管在深交所互动易平台上与投资者进行交流的内容，原汁原味得还原上市公司突发情况</p>
          <p>4、具备搜索功能，可以搜索我们感兴趣的机构。通过关键字就能罗列出所有相关行业板块中凡是有过被调研的行业成份股数据</p>
          <img src="../../assets/images/product/113/img09.jpg" alt />
        </section>
        <section v-show="subMenuId == 7">
          <h2>大数据掘金</h2>
          <p>大数据掘金：在这金融数据大爆炸背景下，投资者想要高效的筛选出有效信息需要付出</p>
          <p>越来越多的时间与精力，大数据掘金通过海量，AI智能匹配，以快、准、精的三字诀，列出细分题材中的所有个股，让投资者进行梳理，选出最有潜力的个股。</p>
          <img src="../../assets/images/product/113/img10.jpg" alt />
        </section>
        <section v-show="subMenuId == 8">
          <h2>竞价洞察</h2>
          <p>竞价洞察：集合竞价是每个交易日非常重要的环节，集合竞价有异动的个股，主力在集合竞价期间的动向往往给当日走势奠定了基调；集合竞价结束时涨幅居前或跌幅居前的个股有没有板块效应，或热门板块在集合竞价期间的表现如何，透露了大部分主力的意图；在集合竞价成交当中，超大资金的整体买卖方向也反应了他们对当日行情的多空态度。</p>
          <img src="../../assets/images/product/113/img11.jpg" alt />
        </section>
        <section v-show="subMenuId == 9">
          <h2>热点轮动</h2>
          <p>热点轮动：通过对历史数据和资金的观察来寻找出即将轮动到的热点。 热点板块轮记录各个热点板块的轮动轨迹动并综合评定市场“真”热点，智能区分板块龙头股，并提供热点板块的ACE指数BBD(大盘先锋)数据。</p>
          <img src="../../assets/images/product/113/img12.jpg" alt />
        </section>
        <section v-show="subMenuId == 10">
          <h2>董秘爆料</h2>
          <p>董秘爆料：董秘爆料是一款便于投资者第一手时间拿到投资者与董秘互动消息，同时大智慧每天会实时推荐市场热点予投资者定阅资讯，资深投资者也可以按自己要求定阅第一手资讯</p>
          <img src="../../assets/images/product/113/img13.jpg" alt />
        </section>
      </article>
      <article v-show="menuId == 3">
        <section v-show="subMenuId == 1">
          <h2>DDE排行</h2>
          <p>DDE排行：监控资金进出轨迹</p>
          <p>用法：1、DDX 阶段值排行(由高到低)表示一个阶段大单买入净量占流通盘比率靠前的股票，可以找出主力阶段建仓的股票，可以发现一些中线牛股，这些股票在短线回调时是很好的买入机会。</p>
          <p>2、DDY 阶段值排行(由高到低)表示一个阶段散户卖出最多的股票，可以发现一些主力悄悄建仓的股票。</p>
          <p>3、DDC 指标排序(由高到低)包括了N 天内DDX 翻红天数和DDX 连续翻红天数两种排序，对于追踪一段时间内连续建仓的股票具有重要作用。排序靠前的即最近不断有大资金参与的股票、大资金连续建仓的股票。软件中的N 默认为10，参数可设。</p>
          <img src="../../assets/images/product/113/img14.jpg" alt />
        </section>
        <section v-show="subMenuId == 2">
          <h2>SV资金流向</h2>
          <p>SV资金流向：监控板块资金进出情况</p>
          <p>根据当天板块资金流入最多和流出最多的板块来确定，当天的热钱的踪迹</p>
          <img src="../../assets/images/product/113/img15.jpg" alt />
        </section>
        <section v-show="subMenuId == 3">
          <h2>ACE决策</h2>
          <p>ACE决策：最新资金计算模型，资金流向结构更精准</p>
          <p>用法：1、如果当日ACX红绿柱线为红色表示当日活跃资金大单买入量较大且ACY为正主动买入较多，反之如果当日红绿柱线为绿色表示主动性大单卖出较多。</p>
          <p>2、3线持续向上主力买入积极，表示筹码在持续向少数人转移，有主力资金收集，股价有持续的上涨动力。</p>
          <p>3、股价上涨3线却向下，表明是游资短线和散户行情，一般不具备长期的上涨动力。</p>
          <p>4、涨跌动因指标所要在一个较长的周期内观察，如果一段时间3线持续向上，那么每次股价回调就是买入良机。相反如果上涨时3线持续向下，那么短线超买就是减仓良机。</p>
          <img src="../../assets/images/product/113/img16.jpg" alt />
        </section>
        <section v-show="subMenuId == 4">
          <h2>北向资金</h2>
          <p>北向资金：依据香港联合交易所每日盘后公布的陆股通持股数量和占流通A股比例数据，统计每日全部陆股通资金的整体方向，行业和个股偏好，辅助投资者及时掌握香港投资者的资金动向，挖掘投资机会。</p>
          <p>用法：1、包含市场风向、当日净买入额TOP10(估计值)、当日增仓占比TOP10、连续增仓TOP10、10日净买金额TOP10(估计值)、10日累计增仓占比TOP10、10日净买金额板块TOP10(估计值)7个子模块。</p>
          <p>2、统计了全市场所有沪股通、深股通标的股北向资金的持股变化、持股市值变化(净买入额)、占流通A股比例、占流通A股比例变化、连续增仓天数、持股数量和持有市值的数据；同时还根据A股短中期资金轮动的平均周期范围，提供了不同周期(5日、10日、20日、45日)的统计数据；</p>
          <p>3、北向资金风格偏向于价值投资，很少参与A股热门概念题材的炒作，因此本功能对板块资金的统计，限于大智慧行业分类，以便让北向资金的投资脉络表现的更清晰。</p>
          <img src="../../assets/images/product/113/img17.jpg" alt />
        </section>
        <section v-show="subMenuId == 5">
          <h2>资金动向</h2>
          <p>当资金动向出现蓝柱，说明活跃大资金整体以卖出为主，当蓝柱长度逐步变短，红绿线在零轴下方变红时，说明短线大资金净卖出力度正逐步减小，做空力量在减弱。当出现红柱并且长度逐步放大，红绿线持续为红线，说明活跃大资金整体以买入为主，拉升股价意愿明显，此时应持股待涨。</p>
          <p>当红柱长度变短，红线变绿线持续向下时，说明大资金获利回吐迹象明显，此时应逐步逢高减仓；当红柱变绿柱，绿线持续向下时，说明活跃大资金整体以卖出为主，股价下跌风险较大，此时应注意规避风险。直到兰柱长度减小，绿线翻红。</p>
          <img src="../../assets/images/product/113/img18.jpg" alt />
        </section>
        <section v-show="subMenuId == 6">
          <h2>超赢分析</h2>
          <p>超赢分析：该分析模板包括六大功能：超赢散户线、超赢主力持仓、超赢资金流、超赢盘中趋势分析、超赢实时监控、超赢分类统计。</p>
          <img src="../../assets/images/product/113/img19.jpg" alt />
        </section>
      </article>
      <article v-show="menuId == 4">
        <section v-show="subMenuId == 1">
          <h2>全息高速盘口</h2>
          <p>全息高速盘口：真实还原交易方向和成交细节。</p>
          <p>用法：1、显示全部价位的买卖盘信息</p>
          <p>2、鼠标在主图中停留半秒，显示该笔成交的详细，包括双方委托的价、量。</p>
          <img src="../../assets/images/product/113/img20.jpg" alt />
        </section>
        <section v-show="subMenuId == 2">
          <h2>龙虎榜</h2>
          <p>龙虎榜：揭秘游资参与个股和参与强度，证监会规定上证、深圳主板、中小板、创业板针对</p>
          <p>下列情况的前三名进行公布。</p>
          <p>1、当日涨幅偏离值达到±7%</p>
          <p>2、当日振幅达到 15%</p>
          <p>3、当日换手率达到 20%</p>
          <p>4、3 日内涨幅累计偏离值达到 20%</p>
          <img src="../../assets/images/product/113/img21.jpg" alt />
        </section>
        <section v-show="subMenuId == 3">
          <h2>融资融券</h2>
          <p>融资融券：融资融券是指投资者向具有融资融券业务资格的证券公司提供担保物，借入资金买入证券（融资交易）或借入证券并卖出（融券交易）的行为。包括券商对投资者的融资、融券和金融机构对券商的融资、融券。从世界范围来看，融资融券制度是一项基本的信用交易制度</p>
          <p>用法：1、融资余额指投资者每日融资买进与归还借款间的差额的累积。融资余额若长期增加时，表示投资者心态偏向买方，市场人气旺盛，属强势市场；反之则属弱势市场。融资余额简单地说，就你还可以在证券市场上借多少钱。</p>
          <p>
            2、融券余量：指投资者每日融券卖出与买进还券间的差额。融券余额增加，表示看空的投资仓位增加，市场趋向卖方；反之则趋向买方。
            它的市场含义是融资余额越大，融券余额越小，那么悲观看空情绪越大。
          </p>
          <img src="../../assets/images/product/113/img22.jpg" alt />
        </section>
      </article>
      <article v-show="menuId == 5">
        <section v-show="subMenuId == 1">
          <h2>九转交易</h2>
          <p>汤姆·狄马克(Tom DeMark)技术分析领域最有名的大师之一，对全球股市各大指数都做出过精准预测，被人们封为“预言帝”。他是股市拐点指标的创建者，他的TD序列交易系统用于识别市场趋势的潜在转折点。</p>
          <p>大智慧九转交易以发现走势拐点为出发点，旨在为投资者提供一套提高逃顶、抄底胜率的决策模型。它有四大优势：</p>
          <p>【警示风险】：当上涨9结构结束时，提示顶部风险并给出压力参考线（深海绿色虚线）</p>
          <p>【发现底部】：当下跌9结构结束时，大概率形成阶段底部，大概率出现新的上涨，并给出支撑线(番茄红色虚线)</p>
          <p>【研判大势】：沪、深、中小企业、创业板指数均适用</p>
          <p>【信号预警】：可进行条件选股(选股前下载日线数据)、预警、也可作为股票池的过滤条件</p>
          <img src="../../assets/images/product/113/img19.png" alt />
        </section>
        <section v-show="subMenuId == 2">
          <h2>黄金坑</h2>
          <p>黄金坑：个股前期经过较长时间的横盘或者小角度上行筑底，主力在确定拉升行情前，受大盘非理性急跌影响，引发跟风者和不坚定持仓者下马股价重挫。待不确定利空消失后，原有主力反手做多。股价便迅速从坑中拔地而起，一波波澜壮阔的行情随之展开，在K线图上就形成了一个形似坑状的图型叫黄金坑。</p>
          <p>使用技巧：</p>
          <p>1、：三线持续向上股价有持续的上涨动力。</p>
          <p>2、：三线金叉多头向上为短期反弹趋势</p>
          <p>3、：黄色毛刷状“黄金坑”形态；</p>
          <img src="../../assets/images/product/113/img24.jpg" alt />
        </section>
        <section v-show="subMenuId == 3">
          <h2>短仓波动</h2>
          <p>短仓波动：短仓波动是一个短中线兼顾的技术指标，投资者在使用的时候可以用适当的仓位进行波段操作。D1线表示短线资金的攻击力度，D2线表示长线资金的攻击力度。当D1线从下方金叉D2线的时候意味着短期短线资金攻击力度大于长线资金攻击力度，将会在低位出现红柱，为向信号，同时指标彩带为红色，表示该区域以做多为主</p>
          <p>用法：1、红色彩带上穿超买线（数值80），风险较高，如果个股有转弱，可考虑控制风险；</p>
          <p>2、绿色彩带跌穿见底线（数值20）同时出现网格状底部区域，抄底机会大；</p>
          <p>3、当低位出现红柱，为向信号，同时指标彩带为红色，表示该区域以做多为主</p>
          <p>4、当彩带为绿色，由多转空，表示该区域以规避为主。</p>
          <img src="../../assets/images/product/113/img25.jpg" alt />
        </section>
        <section v-show="subMenuId == 4">
          <h2>双突战法</h2>
          <p>双突战法 ：通过“一突异动、二突关注”定位盘中资金突击的信号。</p>
          <p>1、重视日内大盘分时波动线，买在指数由弱转强阶段。</p>
          <p>2、参与更容易被市场资金接受的股票品种，如热门题材活跃股。股价回踩充分后，上升拐点出现时短线追涨风险小。</p>
          <p>3、看中做短。即看好中线开始走强的前题下进行短线操作。</p>
          <p>4、每日10点30后预警监控较为安全，因为开盘一小时后前一日的消息面因素干扰基本消除，大盘涨跌方向亦较为明朗。重视14点-14点30个股信号。</p>
          <img src="../../assets/images/product/113/img26.jpg" alt />
        </section>
        <section v-show="subMenuId == 5">
          <h2>抄底资金</h2>
          <p>抄底资金该指标适合于处于长期上行趋势中出现的回调或震荡走势；不适合向下和窄幅震荡的行情</p>
          <p>1、当黄色实线下穿进入机会区(红色点状线)时，表示股价已经超跌，短期或迎来向上反弹行情。若出现红色箭头，则表示该区域为短期底部的概率很大。</p>
          <p>2、当黄色实线上穿进入风险区(绿色点状线)，表示股价已经超涨，该区域风险加大，不宜追高；</p>
          <p>3、条件选股时，选择X大于0，使用除权后数据，分析周期用日线周期。</p>
          <img src="../../assets/images/product/113/img27.jpg" alt />
        </section>
      </article>
      <article v-show="menuId == 6">
        <section v-show="subMenuId == 1">
          <h2>level-2行情</h2>
          <p>level-2行情：由沪深交易所授权发布，包括十档行情，买卖队列，逐笔成交，委托总量和加权价格等多种新式数据，大智慧新一代对交易所提供的实时Level-2行情数据进行更深层次地分析，提供更具实战意义的Level-2深度行情数据，因为其最接近于市场真实交易成交情况，所以具有极大的信息含金量，满足客户差异化信息需求</p>
          <img src="../../assets/images/product/113/img28.jpg" alt />
        </section>
        <section v-show="subMenuId == 2">
          <h2>资金先锋</h2>
          <p>资金先锋采用DDE+ACE的方式体现大资金的参与深度与拉升股价的意愿。该指标，分为分时和K线指标</p>
          <p>用法： 1、资金先锋指标线数值越大说明大资金参与的越多，股价快速上涨的概率越大；当资金先锋指标线数值快速放大或者大于30时翻红。</p>
          <p>2、反之：指标线数值越小说明大资金出逃的越多，股价下跌的概率越大；当资金先锋指标线数值快速减小或者小于-30时翻绿。</p>
          <p>3、红绿柱代表每分钟大资金运作的方向变化，红柱代表大资金流入，绿柱代表大资金流出。</p>
          <p>4、日内可关注资金先锋数值较大，涨幅较小的个股，回避资金先锋数值较小的个股。</p>
          <img src="../../assets/images/product/113/img29.jpg" alt />
        </section>
        <section v-show="subMenuId == 3">
          <h2>主动笔数</h2>
          <p>主动笔数：按逐笔成交统计的主动性买入笔数和主动性卖出笔数的差，当日累计值，红线为主动性买入笔数，绿线为主动性卖出笔数，红绿柱为笔数差，比例=笔数差/(买入笔数+卖出笔数)*100。</p>
          <p>用法1、当出现红色箭头时，表明股价可能会出现上涨，反之则下跌</p>
          <p>2、当毛刷柱开始连续放大说明主动买入资金开始连续增多，反之则减少</p>
          <p>3、当红线买入线向上趋势，并远远大于绿色买入线时股价将快速拉升。</p>
          <img src="../../assets/images/product/113/img30.jpg" alt />
        </section>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      menuId:1,
      subMenuId:1,
      menuList: [
        {
          id: 1,
          name: "大盘分析系统",
          subMenuList: [
            { id: 1, name: "封板率" },
            { id: 2, name: "大盘先锋" },
            // { id: 3, name: "EDX 申赎动向" }
          ]
        },
        {
          id: 2,
          name: "策略捉妖",
          subMenuList: [
            { id: 1, name: "昨日涨停分析" },
            { id: 2, name: "ACE涨跌排序" },
            { id: 3, name: "主题投资" },
            { id: 4, name: "股东深挖" },
            { id: 5, name: "复盘神器" },
            { id: 6, name: "机构去哪" },
            { id: 7, name: "大数据掘金" },
            { id: 8, name: "竞价洞察" },
            { id: 9, name: "热点轮动" },
            { id: 10, name: "董秘爆料" }
          ]
        },
        {
          id: 3,
          name: "热钱进出轨迹",
          subMenuList: [
            { id: 1, name: "DDE排行" },
            { id: 2, name: "SV资金流向" },
            { id: 3, name: "ACE决策" },
            { id: 4, name: "北向资金" },
            { id: 5, name: "资金动向" },
            { id: 6, name: "超赢分析" }
          ]
        },
        {
          id: 4,
          name: "交易统计类",
          subMenuList: [
            { id: 1, name: "全息高速盘口" },
            { id: 2, name: "龙虎榜" },
            { id: 3, name: "融资融券" }
          ]
        },
        {
          id: 5,
          name: "趋势拐点系统",
          subMenuList: [
            { id: 1, name: "九转交易" },
            { id: 2, name: "黄金坑" },
            { id: 3, name: "短仓波动" },
            { id: 4, name: "双突战法" },
            { id: 5, name: "抄底资金" }
          ]
        },
        {
          id: 6,
          name: "分时擒牛系统",
          subMenuList: [
            { id: 1, name: "level-2行情" },
            { id: 2, name: "资金先锋" },
            { id: 3, name: "主动笔数" }
          ]
        }
      ]
    };
  },
  methods: {
    selectMenu(menuId){
      this.menuId = menuId;
      this.subMenuId = 1;
    },
    selectSubMenuId(menuId, subMenuId){
      this.menuId = menuId;
      this.subMenuId = subMenuId;
    }
  }
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/product/ProductDetail113.vue